import { render, staticRenderFns } from "./CompanyActions.vue?vue&type=template&id=247cadd2&scoped=true"
import script from "./CompanyActions.vue?vue&type=script&lang=js"
export * from "./CompanyActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cadd2",
  null
  
)

export default component.exports